import React from 'react';
import styles from './styles.module.scss';

const LockControl = ({
  lockStatus,
  hasLock,
  onAcquireLock,
  onReleaseLock,
  onForceOverride,
  isLoading = false,
  isInitializing = false,
}) => {
  const { locked, locked_by_name, locked_at } = lockStatus || {};

  const formatLockTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const diffMs = Date.now() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    return date.toLocaleDateString();
  };

  if (isInitializing) {
    return (
      <div className={styles.wrapper}>
        <span className={`${styles.dot} ${styles.dotMuted}`} />
        <span className={styles.label}>
          <span className={styles.spinner} />
          Checking lock…
        </span>
      </div>
    );
  }

  const otherUserHasLock = locked && !hasLock;

  let state = 'unlocked';
  let label = 'Read-only';
  let action = null;

  if (hasLock) {
    state = 'mine';
    label = 'Editing';
    action = (
      <button
        type="button"
        className={styles.action}
        onClick={onReleaseLock}
        disabled={isLoading}
        title="Release lock so others can edit"
      >
        {isLoading ? (
          <>
            <span className={styles.spinner} /> Releasing…
          </>
        ) : (
          'Release'
        )}
      </button>
    );
  } else if (otherUserHasLock) {
    state = 'other';
    label = (
      <>
        Locked by <strong>{locked_by_name}</strong>
        {locked_at && (
          <span className={styles.muted}> · {formatLockTime(locked_at)}</span>
        )}
      </>
    );
    action = (
      <button
        type="button"
        className={`${styles.action} ${styles.actionDanger}`}
        onClick={onForceOverride}
        disabled={isLoading}
        title="Force override — will boot the other editor"
      >
        {isLoading ? (
          <>
            <span className={styles.spinner} /> Taking…
          </>
        ) : (
          'Override'
        )}
      </button>
    );
  } else {
    state = 'unlocked';
    label = 'Read-only';
    action = (
      <button
        type="button"
        className={styles.action}
        onClick={onAcquireLock}
        disabled={isLoading}
        title="Acquire lock to edit"
      >
        {isLoading ? (
          <>
            <span className={styles.spinner} /> Taking…
          </>
        ) : (
          'Take lock'
        )}
      </button>
    );
  }

  return (
    <div className={styles.wrapper}>
      <span
        className={`${styles.dot} ${
          state === 'mine'
            ? styles.dotMine
            : state === 'other'
            ? styles.dotOther
            : styles.dotMuted
        }`}
      />
      <span className={styles.label}>{label}</span>
      {action}
    </div>
  );
};

export default LockControl;
